import { isSameMonth } from "date-fns/isSameMonth";
import { parse } from "date-fns/parse";
const HOLIDAY_DATE_FORMAT = 'yyyyMMdd';
function toEntries(holidays) {
    if (!holidays) return [];
    return Object.entries(holidays).map(([dateKey, name])=>({
            dateKey,
            date: parse(dateKey, HOLIDAY_DATE_FORMAT, new Date()),
            name
        }));
}
function getHolidaysInMonth(holidays, month) {
    return toEntries(holidays).filter((holiday)=>isSameMonth(holiday.date, month)).toSorted((a, b)=>a.dateKey.localeCompare(b.dateKey));
}
export { getHolidaysInMonth };
